import { render, staticRenderFns } from "./cg-level-progress.vue?vue&type=template&id=013e8efe&scoped=true&"
import script from "./cg-level-progress.vue?vue&type=script&lang=js&"
export * from "./cg-level-progress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013e8efe",
  null
  
)

export default component.exports